import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { fleetUserSchema } from '../schemas/fleet-user.schema';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Get a user for your company including fleet information
 * @assetId params User Paged Collection Params
 * @returns Paged Collection of Users
 */
export function getUsersFleetInfoAsset(this: unknown, assetId: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).usersFleetInfoUrl}?AssetIds=${encodeURIComponent(assetId)}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
        }
      )
    )
  ).pipe(selectData(createPagedCollectionSchema(fleetUserSchema)));
}
